import {
	DEFAULT_POLL_MS,
	DEFAULT_STORAGE_DISMISSED_KEY,
	NOTICE_CHANNELS,
	NOTICE_PRODUCTS,
} from "@ilocalbox/system-notices-client";

export const LOG_PREFIX = "[SystemNotices:portal]";

export const STORAGE_DISMISSED_KEY = DEFAULT_STORAGE_DISMISSED_KEY;

export { DEFAULT_POLL_MS, NOTICE_CHANNELS };

export const PRODUCT = NOTICE_PRODUCTS.PORTAL;



// WEBPACK FOOTER //
// ./src/system-notices/constants.js